export default __webpack_public_path__ + "static/modsec-4d185cd726c9bc7246f50ca279fbdb11.png";